import styled from '@emotion/styled/macro';

import { StandardText } from '../../Typography/Typography';

export const Text = styled(StandardText)`
  margin-bottom: 1rem;
`;
